import { useLocation } from 'react-router';
import qs from 'query-string';
import { initialRoute } from './initialRoute';

export const useSimpleQueryStringHelper = () => {
  const { search, pathname } = useLocation();
  const { simple, ...rest } = qs.parse(search) as Record<string, string>;
  const hasSimpleDocument = !!simple;
  const otherSearchString = `?${qs.stringify(rest)}`;

  if (hasSimpleDocument) {
    initialRoute.set(`${pathname}${otherSearchString}`);
  }

  const redirectPath = `/simple/${simple}${otherSearchString}`;

  return {
    hasSimpleDocument,
    redirectPath,
  };
};
